/**
 * ユーザーの表示名・アイコンに関する共通ヘルパー。
 * 管理者コンソール（オーナー列/表示名列）とマイページのプロフィール表示から使う。
 */

/** nickname が無いユーザーの表示名フォールバック（email のローカル部 → sub の先頭8文字 → '—'）。 */
export function displayNameFallback(email?: string | null, sub?: string | null): string {
  if (email) return email.split('@')[0];
  if (sub) return sub.slice(0, 8);
  return '—';
}

/** アイコン + 表示名を横並びで表示するチップ。iconUrl が無ければ頭文字の丸バッジで代替する。 */
export function UserAvatarChip({
  iconUrl,
  name,
  size = 24,
}: {
  iconUrl?: string;
  name: string;
  size?: number;
}) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, minWidth: 0 }}>
      {iconUrl ? (
        <img
          src={iconUrl}
          alt=""
          style={{
            width: size,
            height: size,
            borderRadius: '50%',
            objectFit: 'cover',
            flexShrink: 0,
          }}
        />
      ) : (
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: size,
            height: size,
            flexShrink: 0,
            borderRadius: '50%',
            background: 'var(--color-accent-soft)',
            color: 'var(--color-accent-dark)',
            fontWeight: 700,
            fontSize: size * 0.5,
          }}
        >
          {name.slice(0, 1).toUpperCase()}
        </span>
      )}
      <span
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {name}
      </span>
    </span>
  );
}
